module.exports = __webpack_public_path__ + "static/media/checklist-white-bg.e656dcb1.svg";